import { render, staticRenderFns } from "./DistributorSecondGoodsIndex.vue?vue&type=template&id=07097b2c"
import script from "./DistributorSecondGoodsIndex.vue?vue&type=script&lang=js"
export * from "./DistributorSecondGoodsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports